import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=3bc472db"
import script from "./EmployeeForm.vue?vue&type=script&lang=js"
export * from "./EmployeeForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&id=3bc472db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports